import React from 'react';
import { Skeleton } from '@mui/material';

export const FullReportLoading:React.FC = () => {
    return <Skeleton animation="wave" style={{ height: "100%" }} />
}